import * as React from 'react'
import { Connect } from '@selkirk-systems/state-management';
import UIStore from '@@/stores/UIStore';
import { FULL_DATE_TIME_FORMAT } from '@@/constants/UIConstants';
import { format as dateFormat } from 'date-fns'
import { Skeleton } from 'primereact/skeleton';

class UpdatedText extends React.Component{


    static subscribe=[UIStore];


    static defaultProps={
        date:null,
        format:FULL_DATE_TIME_FORMAT
    }


    static storeStateToProps={
        date:(props,state)=>state.lastEntityUpdate
    }


    render(){
        const {date,format} = this.props;

        if(!date) return <Skeleton width="200px" height="50"/> 
        
        const finalValue = dateFormat( new Date( date ), format);

        return (
            finalValue
        )
    }


}


export default Connect( UpdatedText );